import { uniqueId } from 'lodash-es';

export class WorkerInterval {
    private worker?: Worker;
    private blobURL?: string;
    private fallbackInterval?: ReturnType<typeof setInterval>;
    private abort!: AbortController;

    constructor(callback: (timestamp: number) => void, intervalMs: number) {
        if (false === 'Worker' in window) {
            // fallback if WebWorkers is not supported
            this.fallbackInterval = setInterval(() => callback(performance.now()), intervalMs);
            return this;
        }

        const workerId = uniqueId('web-workers$');
        const blob = new Blob([`setInterval(() => postMessage({ id: '${workerId}', timestamp: Date.now() }), ${intervalMs});`], { type: 'text/javascript' });
        this.abort = new AbortController();
        this.blobURL = URL.createObjectURL(blob);
        this.worker = new Worker(this.blobURL);
        this.worker.addEventListener('message', e => {
            if (e.data.id !== workerId) return;

            callback(performance.now());
        }, { capture: true, signal: this.abort.signal });
    }

    stop() {
        this.abort.abort();
        this.worker?.terminate();
        if (this.blobURL)
            URL.revokeObjectURL(this.blobURL);
        if (this.fallbackInterval)
            clearInterval(this.fallbackInterval);
        this.worker = undefined;
    }
}